import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { useHeaderMeta } from 'pages/tours/search-result-page/model'

import hotTourStore from 'entities/tour/models/hot-tours/hot-tour.ts'
import { TourDetail } from 'entities/tour/ui/tour-detail'

import s from './styles.module.scss'

const HotTourDetailPage = observer(() => {
  const { hotelId } = useParams() as { hotelId: string }

  const tourDetail = hotTourStore.getTourDetail()

  const { title: titleFromMeta, subtitle: subtitleFromMeta } = useHeaderMeta()

  const isLoading = hotTourStore.isLoading
  const isError = hotTourStore.isError

  const getTour = async () => {
    await hotTourStore.requestHotTourDetail(hotelId)
  }

  useEffect(() => {
    void getTour()
  }, [])

  return (
    <div className={s.container}>
      <TourDetail
        isError={isError}
        hotelDetail={tourDetail}
        isLoading={isLoading}
        title={titleFromMeta}
        subtitle={subtitleFromMeta}
      />
    </div>
  )
})

export default HotTourDetailPage
